import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpUtils} from "../shared/http.utils";
import {BasicFilters} from "../model/filters/basic-filters";
import {UserPersistRequest} from "../model/requests/user-persist-request";
import {UserFilters} from '../model/filters/user-filters';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private readonly usersURL: string;

  constructor(private http: HttpClient) {
    this.usersURL = '/catalog/users';
  }

  public getUsers(offset?: number, limit?: number, filters?: UserFilters): Observable<any> {
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new BasicFilters();
    return this.http.post<any>(this.usersURL, body, options);
  }

  public getApplicationsName() {
    return this.http.get<any>('/catalog/applications/summaries');
  }

  public getUser(userUuid: string, tenantUuid: string) {
    let url = `${this.usersURL}/${userUuid}/tenant/${tenantUuid}`;
    return this.http.get<any>(url);
  }

  public createUser(userCreationData: UserPersistRequest) {
    let url = `${this.usersURL}/create`;
    return this.http.post<any>(url, userCreationData);
  }

  public editUser(userCreationData: UserPersistRequest) {
    let url = `${this.usersURL}/${userCreationData.uuid}/tenant/${userCreationData.tenantUUID}`;
    return this.http.put<any>(url, userCreationData);
  }

  public deleteUser(userUuid: string, tenantUuid: string) {
    let url = `${this.usersURL}/${userUuid}/tenant/${tenantUuid}`;
    return this.http.delete<any>(url, {observe: 'response'});
  }

  public deleteUsers(uuids: {uuid: string}[]) { //TODO struct of Pairs <TenantUUID, UserUUID>
    let url = `${this.usersURL}/delete`;
    return this.http.post<any>(url, uuids, {observe: 'response'});
  }

}
